import { evaluateConditionGroup, } from '../../conditions/conditions';
import { containsOperationRuntimeConfig, createRuntimeOperationType, } from './common';
export const filterListContentNodeOperationType = createRuntimeOperationType({
    kind: 'FILTER_LIST_CONTENT_NODE',
    dependencies: () => [],
    run: (value, context) => {
        const [list, condition] = value;
        if (!list) {
            return null;
        }
        if (typeof list !== 'object' || !('kind' in list) || list.kind !== 'LIST') {
            return list;
        }
        const listItems = list.items ?? [];
        const filteredItems = [];
        for (const item of listItems) {
            const processedCondition = context.processRuntimeConfig(condition, {
                ...context,
                item,
            });
            if (containsOperationRuntimeConfig(processedCondition)) {
                return listItems;
            }
            if (evaluateConditionGroup(processedCondition)) {
                filteredItems.push(item);
            }
        }
        const newList = {
            ...list,
            data: filteredItems.map((item) => item.data),
            items: filteredItems,
        };
        return newList;
    },
});
//# sourceMappingURL=filter-list-content-node.js.map